import React from "react";

import styles from "./SelectedRowCard.module.css";

const SelectedRowCard = ({ new_style, children }) => {
  return <div className={styles.SelectedRowCard} style={{ ...new_style }}>{children}</div>;
};

export default SelectedRowCard;
